import { render, staticRenderFns } from "./veStuHealthAsk.vue?vue&type=template&id=190dd278&scoped=true"
import script from "./veStuHealthAsk.vue?vue&type=script&lang=js"
export * from "./veStuHealthAsk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190dd278",
  null
  
)

export default component.exports